export const dictionary = {
    cs: {
        "vyberteSluzbu": "Vyberte službu",
        "breadcrumb.predmetNavstevy": "Předmět návštěvy",
        "breadcrumb.termin": "Termín",
        "breadcrumb.osobniInformace": "Osobní informace",
        "page.skupina": "skupina",
        "page.sluzba": "sluzba",
        "page.kontakt": "kontakt",
        "page.odeslano": "odeslano",
        "dateTimeSelector.jakyTerminVamVyhovuje": "Jaký termín vám vyhovuje?",
        "dateTimeSelector.vyrizeniZadostiJeMozneIBezElObj": "Vyřízení žádostí je možné i bez elektronického objednání, sledujte prosím",
        "dateTimeSelector.aktualniObsazenostPrepazek": "aktuální obsazenost přepážek",
        "dateTimeSelector.nizeNajdeteVolneTerminy": "Níže najdete volné termíny pro elektronické objednání na následujících {numberOfFollowingDays} dnů.",
        "dateTimeSelector.pokudNebylyNalezenyDostupneTerminy": "Pokud nebyly nalezeny žádné dostupné termíny, znamená to, že možnost elektronického objednání je pro následujících {numberOfFollowingDays} dnů zcela vyčerpána.",
        "dateTimeSelector.nacitamDostupneDny": "Načítám dostupné dny",
        "dateTimeSelector.nebylyNalezenyZadneDostupneDny": "Nebyly nalezeny žádné dostupné dny",
        "dateTimeSelector.nacitamDostupneCasy": "Načítám dostupné časy",
        "dateTimeSelector.nebylyNalezenyZadneDostupneCasy": "Nebyly nalezeny žádné dostupné časy",
        "dateTimeSelector.objednanimJednohoTerminuRezervujeteCasPouzeProOdbaveniJedneOsoby": "Objednáním jednoho termínu rezervujete čas pouze pro odbavení jedné osoby.",
        "dateTimeSelector.pokracovat": "Pokračovat",
        "form.elektronickeObjednani": "Elektronické objednání",
        "form.naKohoSeBudemeTesit": "Na koho se budeme těšit?",
        "form.jmenoAPrijmeni": "Jméno a příjmení",
        "form.vaseEmailovaAdresa": "Vaše e-mailová adresa",
        "form.telefon": "Telefon",
        "form.rzVozidla": "RZ vozidla",
        "form.zadejteOznaceniVozidla": "Zadejte označení vozidla, u kterého požadujete provést registrační úkon. V případě první registrace vozidla zadejte posledních 7 míst čísla VIN vašeho vozidla. (Názorný příklad: V případě vozidla označeného VIN: TMBGDM9A1KP042788 uveďte znaky P042788.)",
        "form.dokoncitRezervaci": "Dokončit rezervaci",
        "form.error.objednaniSeNepodariloDokoncit": "Objednání se nepodařilo dokončit",
        "form.error.zadejteJmenoAPrijmeni": "Zadejte jméno a příjmení",
        "form.error.zadejteEmail": "Zadejte e-mail",
        "form.error.zadejteEmailVeSpravnemTvaru": "Zadejte e-mail ve správném tvaru",
        "form.error.zadejteTelefon": "Zadejte telefon",
        "form.error.zadejteTelefonVeSpravnemTvaru": "Zadejte telefon ve správném tvaru",
        "form.error.zadejteOznaceniVozidla": "Zadejte označení vozidla, u kterého požadujete provést registrační úkon. V případě první registrace vozidla zadejte posledních 7 míst čísla VIN vašeho vozidla. (Názorný příklad: V případě vozidla označeného VIN: TMBGDM9A1KP042788 uveďte znaky P042788).",
        "summary.shrnutiObjednavky": "Shrnutí objednávky",
        "summary.predmetNavstevy": "Předmět návštěvy",
        "summary.osobniUdaje": "Osobní údaje",
        "summary.jmenoPrijmeni": "jméno příjmení",
        "summary.email": "e-mail",
        "summary.telefon": "telefon",
        "summary.rzTpVozidla": "RZ/TP vozidla",
        "summary.termin": "Termín",
        "summary.upravit": "Upravit",
        "summary.misto": "Místo",
        "success.hotovo": "Hotovo!",
        "success.gratulujemeVaseObjednavkaJeUspesneDokoncena": "Gratulujeme, vaše objednávka je úspěšně dokončená. Na váš e-mail jsme vám poslali potvrzení objednávky spolu s pokyny, jak se k nám dostat a jak se na schůzku připravit.",
        "success.budemeSeNaVasTesit": "Budeme se na vás těšit!",
        "success.mejteSeKrasne": "Mějte se krásně!",
        "cancel.hotovo": "Hotovo!",
        "cancel.vaseRezervaceBylaUspesneZrusena": "Vaše rezervace byla úspěšně zrušena.",
        "cancel.zruseniObjednaniNaUrad": "Zrušení objednání na úřad",
        "cancel.zruseniRezervaceNaUrad": "Zrušení rezervace na úřad",
        "cancel.rezervaciSeNepodariloZrusit": "Rezervaci se nepodařilo zrušit, zkuste to, prosím, znovu.",
        "cancel.pockejteProsim": "Počkejte, prosím",
        "cancel.zrusitRezervaci": "Zrušit rezervaci",
        "error.rezervacniFormularSeNepodariloNacist": "Rezervační formulář se nepodařilo načíst.",
        "error.zkusteToProsimPozdeji": "Zkuste to, prosím, později.",
        "error.obnovitStranku": "Obnovit stránku",
    },
    en: {
        "vyberteSluzbu": "Select a service",
        "page.skupina": "group",
        "page.sluzba": "service",
        "page.kontakt": "contact",
        "page.odeslano": "sent",
        "breadcrumb.predmetNavstevy": "Subject of appointment",
        "breadcrumb.termin": "Term",
        "breadcrumb.osobniInformace": "Personal information",
        "dateTimeSelector.jakyTerminVamVyhovuje": "Which date suits you?",
        "dateTimeSelector.vyrizeniZadostiJeMozneIBezElObj": "Your application can also be treated without electronic reservation. Please check the current availability",
        "dateTimeSelector.aktualniObsazenostPrepazek": "here",
        "dateTimeSelector.nizeNajdeteVolneTerminy": "Below, you can find all available terms for electronic reservations for the following  {numberOfFollowingDays} days.",
        "dateTimeSelector.pokudNebylyNalezenyDostupneTerminy": "If no available terms are found, it means that the electronic reservations are fully booked for the following {numberOfFollowingDays} days.",
        "dateTimeSelector.nacitamDostupneDny": "Loading available days",
        "dateTimeSelector.nebylyNalezenyZadneDostupneDny": "No available days found",
        "dateTimeSelector.nacitamDostupneCasy": "Loading available times",
        "dateTimeSelector.nebylyNalezenyZadneDostupneCasy": "No available times found",
        "dateTimeSelector.objednanimJednohoTerminuRezervujeteCasPouzeProOdbaveniJedneOsoby": "By ordering a term, you reserve time for a single person only.",
        "dateTimeSelector.pokracovat": "Continue",
        "form.elektronickeObjednani": "Electronic reservation",
        "form.naKohoSeBudemeTesit": "Whom should we expect?",
        "form.jmenoAPrijmeni": "Name and surname",
        "form.vaseEmailovaAdresa": "Your e-mail address",
        "form.telefon": "Phone",
        "form.rzVozidla": "Vehicle licence plate number",
        "form.zadejteOznaceniVozidla": "Enter the registration plate number of the vehicle whose registration you want to edit. In the case of a first-time registration, enter the last 7 digits of your vehicle’s VIN. (Example: If the vehicle’s VIN is TMBGDM9A1KP042788, enter P042788.)",
        "form.dokoncitRezervaci": "Confirm the reservation",
        "form.error.objednaniSeNepodariloDokoncit": "Failure completing your order.",
        "form.error.zadejteJmenoAPrijmeni": "Enter your name and surname",
        "form.error.zadejteEmail": "Enter your e-mail address",
        "form.error.zadejteEmailVeSpravnemTvaru": "Enter your e-mail address in correct format",
        "form.error.zadejteTelefon": "Enter your telephone number",
        "form.error.zadejteTelefonVeSpravnemTvaru": "Enter your telephone number in correct format",
        "form.error.zadejteOznaceniVozidla": "Enter the vehicle designation for which you require a registration procedure. In the case of the first registration of a vehicle, enter the last 7 characters of your vehicle's VIN. (Example: For a vehicle designated with VIN: TMBGDM9A1KP042788, enter characters P042788).",
        "summary.shrnutiObjednavky": "Order summary",
        "summary.predmetNavstevy": "Subject of the appointment",
        "summary.osobniUdaje": "Personal information",
        "summary.jmenoPrijmeni": "name surname",
        "summary.email": "e-mail address",
        "summary.telefon": "telephone number",
        "summary.rzTpVozidla": "Vehicle’s registration plate/certificate number",
        "summary.termin": "Term",
        "summary.upravit": "Edit",
        "summary.misto": "Location",
        "success.hotovo": "Done!",
        "success.gratulujemeVaseObjednavkaJeUspesneDokoncena": "Congratulations, your order has been successfully confirmed. We have sent you a confirmation of the reservation to your e-mail, together with instructions on how to get to us and prepare for the appointment.",
        "success.budemeSeNaVasTesit": "We look forward to meeting you!",
        "success.mejteSeKrasne": "Have a nice day!",
        "cancel.hotovo": "Done!",
        "cancel.vaseRezervaceBylaUspesneZrusena": "Your reservation has been successfully cancelled.",
        "cancel.zruseniObjednaniNaUrad": "Cancellation of the appointment",
        "cancel.zruseniRezervaceNaUrad": "Cancellation of the reservation",
        "cancel.rezervaciSeNepodariloZrusit": "Reservation could not be cancelled, please try again.",
        "cancel.pockejteProsim": "Please wait",
        "cancel.zrusitRezervaci": "Cancel the reservation",
        "error.rezervacniFormularSeNepodariloNacist": "Failure loading the reservation form.",
        "error.zkusteToProsimPozdeji": "Please try again later.",
        "error.obnovitStranku": "Refresh page",
    },
};
